import ExcelJS from 'exceljs';
import { verifyRnListOrder } from './verification';
import { extractData } from './extraction';
import exportToExcel from './exportation';

export async function mergeInterwinnerResults(files: File[], rnListOrder?: string[]): Promise<ExcelJS.Buffer> {
  //eslint-disable-next-line
  let { results, radionuclides, unitsReference } = await extractData(files);

  if (rnListOrder) {
    const rnListOrderUpper = rnListOrder.map((rn) => rn.toUpperCase());
    verifyRnListOrder(rnListOrderUpper, radionuclides);
    radionuclides = new Set(rnListOrderUpper);
  }

  return exportToExcel(results, radionuclides, unitsReference);
}
